'use client'
import React, { useState, useMemo } from 'react'
import { useInView } from "react-intersection-observer";
import Heading from './Heading'
import SubHeading from './SubHeading'
import ProductCard from '../../ProductCard';
import useCustomSWR from '@/hook/useCustomSWR';
import { Skeleton } from '@mui/material';
import Link from 'next/link';
import { v4 as uuidv4 } from 'uuid';
import useDeviceType from '@/hook/useDeviceType'
const categoryImg = [
    {
        id: '64b4d04e959d127070891af5',
        img: 'https://res.cloudinary.com/genx21/image/upload/v1728026337/category-section-cms-image/vzh1umhko30mu0zzqlzw.jpg',
    },
    {
        id: '657706484854651840a9f915',
        img: 'https://res.cloudinary.com/genx21/image/upload/v1728026358/category-section-cms-image/iphhhlnmsm6bnstggmcu.jpg',
    },
    {
        id: '659fb50c3f073aa9c092ba64',
        img: 'https://res.cloudinary.com/genx21/image/upload/v1728026359/category-section-cms-image/mochlj7dncvvsgmahgl0.jpg',
    },
    {
        id: '65cf5476d2992b052a326a33',
        img: 'https://res.cloudinary.com/genx21/image/upload/v1728026359/category-section-cms-image/xnfwthzjzrdvhajk0erj.jpg',
    },
    {
        id: '65d31adcd2992b052a328b1b',
        img: 'https://res.cloudinary.com/genx21/image/upload/v1728026359/category-section-cms-image/y4tjupje5l0fl7k7n3dt.jpg',
    },
];

const getImage = (id) => {
    const img = categoryImg.find((img) => img.id === id);
    return img ? img.img : null
}

const CategoryTemplate1 = ({ data }) => {
    const { heading, sub_heading, ids } = data;
    const [selectedId, setSelectedId] = useState(ids[0]?.id)
    const categoriesId = JSON.stringify(ids?.map(d => d.id))
    const { ref, inView } = useInView({
        triggerOnce: true,
        rootMargin: '500px 0px',
        threshold: 0,
    });
    const { data: listData, isLoading } = useCustomSWR(`/v1/cms/get-filter-content?filter_type=parent-category&ids=${categoriesId}&limit=20`, inView)
    const { data: productData, isLoading: productLoading } = useCustomSWR(`/v1/products/get-all-products?filter[parent_category_id][$eq]=${selectedId}&page=1&limit=8&random=yes&stock_product=true`, inView)
    const { selectedName, slug } = useMemo(() => {
        if (!listData?.response?.data && !selectedId) return {};
        const banner = listData?.response?.data?.find((item) => item._id === selectedId);
        return { selectedName: banner?.name, slug: banner?.slug };
    }, [listData?.response?.data, selectedId]);
    const handleChange = (id) => {
        setSelectedId(id)
    }
    if (!inView) return <div id='category' ref={ref}></div>;
    return (
        <div
            ref={ref}
            id='category'
            className='flex flex-col scroll-offset'
        >
            <div className='md:py-3 lg:py-5'>
                <Heading text={heading} />
                <SubHeading text={sub_heading} />
            </div>
            <div className='home-heading w-full '>
                {
                    listData?.response?.data?.map(c => (
                        <CategoryHeadingCard
                            data={c}
                            id={selectedId}
                            key={uuidv4()}
                            handleChange={handleChange}
                        />
                    ))
                }
            </div>
            <div className='grid grid-cols-2 gap-2 sm:grid-cols-3 md:mt-5 md:grid-cols-4 md:gap-5 lg:grid-cols-5'>
                {productLoading
                    ? Array.from({ length: 10 }, (_, index) => (
                        <div
                            key={uuidv4()}
                            className='h-52 w-full overflow-hidden rounded-lg md:h-60'
                        >
                            <Skeleton
                                animation='wave'
                                variant='rectangular'
                                width='100%'
                                height='100%'
                            />
                        </div>
                    ))
                    : null}
                {productData?.productList && productData?.productList.length !== 0 && (
                    <div className='h-52 w-full overflow-hidden md:h-60'>
                        <img
                            src={getImage(selectedId)}
                            alt='category-image'
                            className='h-full w-full object-contain'
                        />
                    </div>
                )}

                {productData?.productList &&
                    productData?.productList.length !== 0 &&
                    productData?.productList.map((product, index) => {
                        return (
                            <ProductCard
                                key={uuidv4()}
                                product={product}
                                style={'w-full h-52 md:h-60 '}
                                iconStyle={`w-5 h-5`}
                                textSize={`text-xs `}
                                quickViewWidth={24}
                                quickViewHeight={24}
                            />
                        );
                    })}
                {productData?.productList && productData?.productList.length !== 0 && (
                    <div className='h-52 w-full overflow-hidden md:h-60'>
                        <img
                            src='https://res.cloudinary.com/genx21/image/upload/v1728026359/category-section-cms-image/hvo7lsxy8aqyeingylpb.jpg'
                            alt='category-image-2'
                            className='h-full w-full object-contain'
                        />
                    </div>
                )}
            </div>
            <div className=' flex flex-col items-center justify-center mt-5 py-2'>
                <Link
                    href={`/${slug}`}
                    className='flex w-fit items-center gap-2 rounded px-4 text-center text-base md:text-lg font-normal text-gray-700'
                >
                    {` Explore ${selectedName} --> `}
                </Link>
                <Link
                    href={`/category`}
                    className='flex w-fit items-center gap-2 rounded px-4 text-center text-base md:text-lg font-normal text-gray-700'
                >
                    {`Explore all category -->`}
                </Link>
            </div>
        </div>
    )
}

export default CategoryTemplate1

const CategoryHeadingCard = ({ handleChange, id, data }) => {
    const deviceType = useDeviceType();
    const { _id, name, image, slug } = data;
    const handleClick = (slug) => {
        if (deviceType === 'laptop') {
            return window.open(`/${slug}`, '_blank');
        }
    };
    const handleDoubleClick = (slug) => {
        if (deviceType !== 'laptop') {
            return window.open(`/${slug}`, '_blank');
        }
    };
    return (
        <div
            className={`cursor-pointer shrink-0 w-36 md:48  xl:w-52 h-fit xl:h-fit hover:scale-100 rounded-lg  overflow-hidden ${id == _id ? 'ring-2 ring-gray-400 ' : 'grayscale filter'}`}
            onMouseOver={() => handleChange(_id)}
            onClick={() => handleClick(slug)}
            onDoubleClick={() => handleDoubleClick(slug)}
        >
            <div className='h-full w-full'>
                <img
                    loading='lazy'
                    width={100}
                    height={100}
                    src={image}
                    alt={name}
                    className='h-full w-full object-cover'
                />
            </div>
        </div>
    )
}